import { combineReducers } from '@reduxjs/toolkit';

import { createListSlice } from './createList';
import { manageListsSlice } from './manageListsPage';
import { secondaryFilterSlice } from './secondaryFilter';

export const manageListsReducers = combineReducers({
  createList: createListSlice.reducer,
  secondaryFilter: secondaryFilterSlice.reducer,
  manageLists: manageListsSlice.reducer,
});
